import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AvailableOsUpdatesReducer, availableOsUpdatesFeatureKey } from './available-os-updates.reducer';
import { AvailableOsUpdatesEffects } from './available-os-updates.effect';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(availableOsUpdatesFeatureKey, AvailableOsUpdatesReducer),
    EffectsModule.forFeature([AvailableOsUpdatesEffects]),
  ],
  providers: [],
})
export class AvailableOsUpdatesStoreModule {}
